import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue, { type BugsnagPluginVueResult } from '@bugsnag/plugin-vue';
import { createSSRApp, h } from 'vue';
import { SettingsRegistry } from '$settings';
import { TranslatorPlugin } from '@procommerce/translator';
import { PicturePlugin } from '@procommerce/picture';
import { VisitorPlugin } from '@procommerce/visitor';
import { Storefront, StoreLayout } from '$components';
import { Views } from '$views';
import { GoogleTagManager, CookieConsent } from '$storefront';

Bugsnag.start({
  apiKey: '988b4b37e441488e655e9e15954c5c15',
  plugins: [new BugsnagPluginVue()],
});

const BugsnagVue = Bugsnag.getPlugin('vue') as BugsnagPluginVueResult;

export function createStorefront({ router, props }) {
  const app = createSSRApp({ render: () => h(router, props) });

  app.use(BugsnagVue);
  app.use(GoogleTagManager);
  app.use(CookieConsent);
  app.use(SettingsRegistry);
  app.use(TranslatorPlugin);
  app.use(PicturePlugin);
  app.use(VisitorPlugin);
  app.use(Storefront);

  return app;
}

export async function createViewResolver(name: string) {
  const component = Views[name] as any;

  if (!component) {
    throw new Error('Component ' + name + ' not found!');
  }

  if (component.layout === undefined) {
    component.layout = StoreLayout;
  }

  return component;
}
